import { Characteristic } from "../../../lib/types/Offer";
import { toHttpFormat } from "../../../lib/utils";
import { DataTypeIdValue } from "../features/CharacteristicsTable/CharacteristicsTableConst/CharacteristicsTableConst";
import {
  CharacteristicValues,
  TableDataCharacteristic,
} from "../features/CharacteristicsTable/CharacteristicsTableTypes";

export const getCharFormatItem = (el: TableDataCharacteristic, objectTypeId?: number) => {
  return ({
    objectTypeId: el.objectId || objectTypeId,
    objectCharTypeId: el.objectCharTypeId,
    specificDicId: el.specificDicId,
    values: el?.values?.map((value) => {
      const valueCharacteristic: CharacteristicValues = {
        isDefault: value.isDefault,
      };

      switch (el.characteristic?.charType?.dataTypeId) {
        case DataTypeIdValue.Число:
          valueCharacteristic.valNum = Number(value.value);
          break;
        case DataTypeIdValue.Строка:
          valueCharacteristic.valStr = String(value.value);
          break;
        case DataTypeIdValue.Дата:
          valueCharacteristic.valDate = toHttpFormat(value.value);
          break;
        case DataTypeIdValue["Целое число"]:
          valueCharacteristic.valNum = Number(value.value);
          break;
        case DataTypeIdValue["Натуральное число"]:
          valueCharacteristic.valNum = Number(value.value);
          break;
        case DataTypeIdValue["Словарный термин"]:
          valueCharacteristic.valDicId = Number(value.value);
          break;
      }

      return valueCharacteristic;
    }),
  } as unknown) as Characteristic;
};
